// extracted by mini-css-extract-plugin
export var active = "_cx-7";
export var container = "_cx-0";
export var evenWidth = "_cx-4";
export var large = "_cx-5";
export var outlet = "_cx-8";
export var slide = "_cx-2";
export var small = "_cx-6";
export var tab = "_cx-3";
export var tabs = "_cx-1";